/*
| Obsazenost (coverage) — rich hover tooltips on the day-grid cells: who covers
| the hour (names) or a gap message. Uses the shared th-tip helper.
*/
import { attachTip } from './tooltip';

const esc = (v: unknown): string => String(v ?? '').replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string
));

const buildCellTip = (cell: HTMLElement): string => {
    const d = cell.dataset;
    const people = (d.ttPeople ?? '').trim();
    const body = people
        ? `<div class="tt-rows"><div class="tt-row"><span class="tt-muted">Pokrývá</span><span>${esc(people)}</span></div></div>`
        : '<div class="tt-rows"><div class="tt-row"><span class="tt-muted">Mezera</span><span>nikdo nepokrývá</span></div></div>';
    return `<div class="tt-emp"><span class="tt-title">${esc(d.ttWp ?? '')} · ${esc(d.ttHour ?? '')}</span>${body}</div>`;
};

// Rozpis sester pill: full name + role + the day's work hours (or absent).
const buildRosterTip = (chip: HTMLElement): string => {
    const d = chip.dataset;
    const rows: string[] = [];
    if (d.ttRole) {
        rows.push(`<div class="tt-row"><span class="tt-muted">Role</span><span>${esc(d.ttRole)}</span></div>`);
    }
    rows.push(d.ttTime
        ? `<div class="tt-row"><span class="tt-muted">Směna</span><span>${esc(d.ttTime)}</span></div>`
        : '<div class="tt-row"><span class="tt-muted">Stav</span><span>Nepřítomen</span></div>');
    return `<div class="tt-emp"><span class="tt-title">${esc(d.ttName ?? '')}</span><div class="tt-rows">${rows.join('')}</div></div>`;
};

export function initCoverage(): void {
    document.querySelectorAll<HTMLElement>('.ob-cell[data-tt-wp]').forEach((cell) => {
        attachTip(cell, () => buildCellTip(cell));
    });
    document.querySelectorAll<HTMLElement>('.rz-chip[data-tt-name]').forEach((chip) => {
        attachTip(chip, () => buildRosterTip(chip));
    });
}
